import {
  ADD_TO_SET_OPPORTUNITIES_STATE_TYPE,
  GET_OPPORTUNITY_FAIL_TYPE,
  GET_OPPORTUNITY_TYPE,
  OPPORTUNITY_STATUS_CHANGE_TYPE,
  OpportunityActions,
  PATCH_OPPORTUNITY_TYPE,
} from '@main-client/src/app/opportunity/opportunity.actions';
import {
  findStateIndexById,
  findStateIndexBySlug,
} from '@main-client/src/app/opportunity/opportunity.helper';
import { OpportunityState } from '@main-client/src/app/opportunity/opportunity.model';

import get from 'lodash-es/get';

const DEFAULT_STATE: OpportunityState[] = [];

export function opportunityReducer(
  state = DEFAULT_STATE,
  action: OpportunityActions,
) {
  switch (action.type) {
    case GET_OPPORTUNITY_TYPE: {
      const stateClone = [...state];
      const stateIndexById = findStateIndexById(state, action.payload._id);
      const stateIndexBySlug = findStateIndexBySlug(state, action.payload.slug);
      const index = 0 <= stateIndexById ? stateIndexById : stateIndexBySlug;
      if (0 <= index) {
        stateClone[index] = {
          ...stateClone[index],
          isLoading: true,
          isLoaded: false,
        };
      } else {
        stateClone.push({
          document: {
            ...action.payload,
          },
          isLoading: true,
          isLoaded: false,
        });
      }
      return stateClone;
    }

    case GET_OPPORTUNITY_FAIL_TYPE: {
      const stateClone = [...state];
      const index = findStateIndexBySlug(
        state,
        action.payload.opportunity.slug,
      );
      if (0 <= index) {
        stateClone[index] = {
          ...stateClone[index],
          isLoading: false,
          isLoaded: true,
          error: action.payload.error,
        };
      } else {
        stateClone.push({
          document: {
            ...action.payload.opportunity,
          },
          isLoading: false,
          isLoaded: true,
          error: action.payload.error,
        });
      }
      return stateClone;
    }

    case ADD_TO_SET_OPPORTUNITIES_STATE_TYPE: {
      const stateClone = [...state];
      const stateIndexById = findStateIndexById(state, action.payload._id);
      const stateIndexBySlug = findStateIndexBySlug(state, action.payload.slug);
      const index = 0 <= stateIndexById ? stateIndexById : stateIndexBySlug;
      const opportunityState = {
        document: {
          ...get(stateClone[index], 'document', {}),
          ...action.payload,
        },
        isLoading: false,
        isLoaded: true,
      };
      if (0 <= index) {
        stateClone[index] = opportunityState;
      } else {
        stateClone.push(opportunityState);
      }
      return stateClone;
    }

    case PATCH_OPPORTUNITY_TYPE: {
      const stateClone = [...state];
      const index = findStateIndexById(state, action.payload._id);
      stateClone[index] = {
        ...stateClone[index],
        document: {
          ...stateClone[index].document,
          ...action.payload,
        },
      };
      return stateClone;
    }

    case OPPORTUNITY_STATUS_CHANGE_TYPE: {
      const stateClone = [...state];
      const index = findStateIndexById(state, action.payload.opportunityId);
      if (0 <= index) {
        stateClone[index] = {
          ...stateClone[index],
          document: {
            ...stateClone[index].document,
            status: action.payload.status,
          },
        };
      }
      return stateClone;
    }

    default:
      return state;
  }
}
